import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectViewNotFoundDescription: {
		id: 'error-pages.project-view-not-found.projectViewNotFoundDescription',
		defaultMessage: 'The view does not exist in this project.',
		description:
			'Description describing that we could not find a page with such url in the project',
	},
	projectNotFoundDescription: {
		id: 'error-pages.project-view-not-found.projectNotFoundDescription',
		defaultMessage:
			'We could not find the project you are looking for. It may have been deleted or your permissions may have changed.',
		description: 'Description for the case when the project may have been deleted',
	},
	goToBrowseProjects: {
		id: 'error-pages.project-view-not-found.goToBrowseProjects',
		defaultMessage: 'View all projects',
		description: 'Button sends the user to the projects search page when the project is not found',
	},
});
